import { createFileRoute } from "@tanstack/react-router";
import { DenomLandingPage } from "@/components/prize-bond/DenomLandingPage";
import { buildPrizeBondLandingHead } from "@/lib/prize-bond-landing-head";

const DENOM = 25000;
const SLUG = "prize-bond-25000-result-today";
const TITLE =
  "Prize Bond 25000 Result Today 2026 - Prize Bond Check Karne Ka Tarika - Check Prize Bond Online";
const DESC =
  "Rs. 25,000 Premium Prize Bond result today — first prize Rs. 5 crore. Registered bond ka online checker with official National Savings Pakistan data.";

const HOW_TO_STEPS = [
  { title: "Rs. 25,000 premium chunein", body: "Denomination bar mein Rs. 25,000 ⭐ chip par tap karein — yeh premium (registered) bond hai." },
  { title: "Registered bond number likhein", body: "Premium bond serial 8 digit tak hota hai — original bond ke upar likha number as-is input mein daalein." },
  { title: "Bulk mode try karein", body: "Agar aap ke paas multiple registered bonds hain to Bulk tab mein sab paste karein (max 100)." },
  { title: "Check aur verify", body: "'Check Karain' dabate hi result draw # aur city ke saath dikhaye ga — registered holder ka naam SBP branch se confirm hota hai." },
  { title: "Claim registered account mein", body: "Prize amount seedha aap ke registered bank account mein transfer hota hai — bearer bond ki tarah cash withdrawal nahi hota." },
];

const FAQS = [
  { q: "Rs. 25,000 prize bond ka result kaise dekhein aaj?", a: "Upar checker mein premium 25,000 chip select karein aur apna 8-digit registered bond number input mein daalein. Hamara data National Savings ki Rs. 25,000 draw PDF se sync hota hai, isliye latest result direct match ho jata hai." },
  { q: "25000 premium prize bond ka first prize kitna hai?", a: "First prize Rs. 5,00,00,000 (5 crore) — 1 winner. Second prize Rs. 1,50,00,000 (1.5 crore) — 3 winners. Third prize Rs. 3,12,000 — 1,696 winners. Yeh Pakistan ka doosra sab se bara prize bond hai Rs. 40,000 ke baad." },
  { q: "Kya Rs. 25,000 bearer hai ya registered?", a: "Rs. 25,000 sirf premium (registered) form mein aata hai — bearer version 2019 mein discontinue kar diya gaya. Iska matlab bond kisi specific CNIC-holder ke naam registered hota hai aur prize seedha uske account mein aata hai." },
  { q: "25000 prize bond draw kab kab hoti hai?", a: "Rs. 25,000 premium bond ka draw har 3 mahine baad hota hai — usually February, May, August, November mein. Exact date National Savings 15 din pehle announce karta hai." },
  { q: "Non-filer 25000 premium bond rakh sakta hai?", a: "Haan — Rs. 25,000 par filer/non-filer restriction nahi hai (yeh restriction sirf Rs. 40,000 par lagti hai). Lekin tax rates alag hain: filer 15%, non-filer 30% prize amount par." },
  { q: "Kya 25000 bond ka profit bhi milta hai prize ke ilawa?", a: "Ji haan, premium bonds regular bearer bonds se is liye alag hain ke inn par 6-monthly profit bhi milta hai — approx 5-7% annualized. Yeh profit prize ke ilawa hota hai aur bank account mein credit hota hai." },
  { q: "25000 wala prize bond kahan se milega?", a: "Sirf SBP Banking Services Corporation aur authorized commercial banks se registration process ke sath milta hai. Application ke waqt CNIC copy, bank account details aur nominee information deni hoti hai." },
  { q: "Agar CNIC change ho gaya to registered bond ka kya hoga?", a: "Aap ko SBP branch mein bond re-registration form bharna hoga — naya CNIC copy, purana record aur photo attach karke. Yeh 15-20 din mein update ho jata hai. Prize claim usi updated record par process hoga." },
  { q: "Rs. 25000 par 5 crore jeetne ke chances kya hain?", a: "Har draw mein sirf 1 first prize nikalta hai. Agar total 25000 bonds circulation mein X hain to chance 1/X hai — typically 1 in 8-10 lakh ke qareeb. Chotay prizes (Rs. 3.12 lakh) 1696 log jeette hain, jin ke chances zyada realistic hain." },
  { q: "Purani draws bhi check hoti hain 25000 bond checker mein?", a: "Haan — jo bhi Rs. 25,000 draws upload hui hain (last 3-4 years tak), un sab ke against aap ke numbers check hote hain. Ek bond number multiple draws mein bhi jeeta ho to sab entries alag dikhayi jati hain." },
];

const RELATED = [
  { href: "/prize-bond-40000-result-today", label: "Rs. 40,000 Premium" },
  { href: "/prize-bond-list-750-today", label: "Rs. 750 Prize Bond" },
  { href: "/prize-bond-1500-result-today", label: "Rs. 1,500 Prize Bond" },
  { href: "/prize-bond-100-result-today", label: "Rs. 100 Prize Bond" },
  { href: "/prize-bond-200-result-today", label: "Rs. 200 Prize Bond" },
  { href: "/prize-bond", label: "All Prize Bonds Hub" },
];

export const Route = createFileRoute("/prize-bond-25000-result-today")({
  head: () =>
    buildPrizeBondLandingHead({
      slug: SLUG,
      title: TITLE,
      description: DESC,
      denomination: DENOM,
      howToName: "How to check Rs. 25,000 Premium Prize Bond result today",
      howToSteps: HOW_TO_STEPS,
      faqs: FAQS,
    }),
  component: Page,
});

function Page() {
  return (
    <DenomLandingPage
      denomination={DENOM}
      h1English="Prize Bond 25000 Result Today — Premium Registered Bond Checker"
      h1Hinglish="25,000 Wala Prize Bond Ka Result Aaj — Foran Check Karain"
      introParagraphs={[
        "Rs. 25,000 Pakistan ka premium (registered) prize bond hai — jackpot Rs. 5 crore ke sath. Yeh bearer nahi hota, isliye har bond kisi specific holder ke CNIC par registered hota hai aur prize direct bank account mein credit hota hai. Is page par aap aaj ka latest draw result checker se seconds mein confirm kar sakte hain.",
        "Data National Savings Pakistan ki official Rs. 25,000 draw PDF se aata hai — jaise hi draw complete hoti hai, hamara backend winners parse karke checker mein feed kar deta hai. Aap ko koi PDF download karne, Ctrl+F chalane ya third-party WhatsApp forwards ka intezar karne ki zarurat nahi.",
        "Neeche checker ke baad Rs. 25,000 ki tax treatment, 6-monthly profit, aur premium vs bearer bond ke faraq par detailed content diya gaya hai — sirf isi denomination ke liye tailor kiya hua.",
      ]}
      keyFacts={[
        { label: "1st Prize", value: "Rs. 5,00,00,000" },
        { label: "2nd Prize (×3)", value: "Rs. 1,50,00,000" },
        { label: "3rd Prize (×1696)", value: "Rs. 3,12,000" },
        { label: "Bond Type", value: "Premium · Registered" },
      ]}
      sections={[
        {
          id: "premium-vs-bearer",
          heading: "Premium vs Bearer — Rs. 25,000 Kyun Alag Hai",
          body: (
            <>
              <p>
                2019 se Rs. 25,000 aur Rs. 40,000 bond sirf premium form mein milte hain — matlab CNIC ke sath registered.
                Bearer bonds (jo koi bhi cash mein le sakta tha) FATF anti-money-laundering requirements ke baad phase out
                ho gaye. Premium ka faida yeh hai ke bond gum ho jaye to bhi record SBP ke sath hota hai, aur regular 6-monthly
                profit bhi milta hai — approximately 5-7% annualized, jo prize ke ilawa hai.
              </p>
              <p>
                Prize claim process bhi easy hai — winner ka registered bank account SBP ke record mein pehle se hai, isliye
                cross cheque manually collect karne ki zarurat nahi rehti. Amount 15-30 din mein direct credit ho jati hai.
              </p>
            </>
          ),
        },
        {
          id: "tax-guide-25k",
          heading: "Tax aur Profit — Realistic Numbers",
          body: (
            <>
              <p>
                Filer ke liye 15% aur non-filer ke liye 30% withholding tax lagta hai jab prize Rs. 5,000 se upar ho.
                Rs. 3,12,000 third prize par filer ko Rs. 2,65,200 aur non-filer ko Rs. 2,18,400 net milte hain. First
                prize Rs. 5 crore par filer ko Rs. 4.25 crore aur non-filer ko Rs. 3.5 crore milega — 75 lakh ka farq.
                Isliye Rs. 25,000 premium bond khareedne wale zyadatar log FBR mein filer hi hote hain.
              </p>
            </>
          ),
        },
      ]}
      howToSteps={HOW_TO_STEPS}
      faqs={FAQS}
      relatedLinks={RELATED}
    />
  );
}
